import { IconButton, Tooltip, Typography } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { isMoment } from 'moment';
import React from 'react';
import { filterTypes } from '../../../utils/filter-utils';
import { formatNumber } from '../../../utils/form-utils';

const AccionesFactura = ({ item, classes, onPdfView, onEdit, onDelete }) => {
  const fileName = item.factura?.[0]?.name;
  return (
    <TableCell className={classes.tableCellAction}>
      <Tooltip title={fileName || 'Ver'} aria-label="ver">
        <IconButton aria-label="ver" onClick={() => onPdfView(item)}>
          <PictureAsPdfIcon />
        </IconButton>
      </Tooltip>
      {onEdit && (
        <Tooltip title="Editar" aria-label="editar">
          <IconButton aria-label="editar" onClick={() => onEdit(item)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip title="Eliminar" aria-label="eliminar">
          <IconButton aria-label="delete" onClick={() => onDelete(item)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}
    </TableCell>
  );
};

const facturasConfig = props => {
  const { classes, enqueueSnackbar, onEdit, onDelete, onPdfView } = props;
  return {
    facturas: {
      datosConfig: {
        titulo: 'Facturas cargadas',
        servicio: 'formulario/eas-administracion',
        url: 'facturas'
      },
      datosSettings: {
        nroFactura: {
          label: 'Nro. de factura',
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              <Typography variant="body2" noWrap>
                {item.nroFactura}
              </Typography>
            </TableCell>
          )
        },
        timbrado: {
          label: 'Timbrado',
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.timbrado || ''}
            </TableCell>
          )
        },
        fechaFactura: {
          label: 'Fecha de factura',
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {isMoment(item.fechaFactura)
                ? item.fechaFactura.format('DD/MM/YYYY')
                : item.fechaFactura}
            </TableCell>
          )
        },
        montoFactura: {
          label: 'Monto',
          type: filterTypes.NUMERIC,
          cellRendering: item => (
            <TableCell className={classes.tableCell} align="right">
              <Typography variant="body2" noWrap>
                {formatNumber(item.montoFactura)}
              </Typography>
            </TableCell>
          )
        },
        actions: {
          label: 'Acciones',
          sortable: false,
          cellRendering: item => (
            <AccionesFactura
              item={item}
              classes={classes}
              enqueueSnackbar={enqueueSnackbar}
              onPdfView={onPdfView}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          )
        }
      }
    }
  };
};

export default facturasConfig;
